/* eslint-disable */
import { Tooltip } from "@mui/material";
import { AnyNsRecord } from "dns";
import React, { InputHTMLAttributes, useEffect, useState } from "react";
import { toast } from "react-toastify";

interface Params {
  PalavrasChave: string;
  PaginaAtual: number;
  TotalItensRetorno: number;
}
interface Props {
  filters: Params;
  setFilters: Function;
  valueFromContext: string;
}

import * as SVGIcon from "../../../../assets/iconsSVG";

import * as Styles from "./styles";

export const SearchBar: React.FC<Props> = ({
  filters,
  setFilters,
  valueFromContext,
}) => {
  const [generalSearch, setGeneralSearch] = useState<string>("");

  useEffect(() => {
    setGeneralSearch(valueFromContext);
  }, []);

  const handleBtnSearch = () => {
    if (generalSearch.length > 2 || generalSearch === "") {
      setFilters({
        ...filters,
        PalavrasChave: generalSearch,
      });
    }
    if (generalSearch.length <= 2 && generalSearch.length > 0) {
      toast.error("Informe no mínimo 3 caracteres");
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      // 👇 Get input value
      if (generalSearch.length > 2 || generalSearch === "") {
        setFilters({
          ...filters,
          PalavrasChave: generalSearch,
        });
      }
      if (generalSearch.length <= 2 && generalSearch.length > 0) {
        toast.error("Informe no mínimo 3 caracteres");
      }
    }
  };

  return (
    <Styles.Container>
      <Styles.Input
        placeholder="Pesquisar por corretor ou lead"
        value={generalSearch}
        onChange={(event) => {
          setGeneralSearch(event.target.value);
        }}
        onKeyDown={handleKeyDown}
        onBlur={() => handleBtnSearch()}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            <Tooltip followCursor title="Pesquisar" placement="top" arrow>
              <span>
                <Styles.BtnSearch
                  color="primary"
                  variant="outlined"
                  onClick={() => handleBtnSearch()}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    minWidth: 36,
                  }}
                >
                  <Styles.PositionIcon position="start">
                    <SVGIcon.SearchIcon />
                  </Styles.PositionIcon>
                </Styles.BtnSearch>
              </span>
            </Tooltip>
          ),
        }}
      />
    </Styles.Container>
  );
};
